/** プロフィール種別：クライアント */
export const PROFILE_TYPE_CLIENT = 'client';
/** プロフィール種別：通常コンサルタント */
export const PROFILE_TYPE_NORMAL_PROFESSIONAL = 'professional';
/** プロフィール種別：フリーコンサルタント */
export const PROFILE_TYPE_FREE_PROFESSIONAL = 'free_professional';
